import script from "./OrgManager.vue?vue&type=script&setup=true&lang=js"
export * from "./OrgManager.vue?vue&type=script&setup=true&lang=js"

import "./OrgManager.vue?vue&type=style&index=0&id=75693a74&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75693a74"]])

export default __exports__